import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketToast, MarketToaster } from '@market/react';
import { useGetActiveBalancesV2Query } from '../../../store/query/api-extensions/rewardsRpcs';
import { RewardName } from 'rpc/model/squareup/rewards/common';

const RewardsTracker: React.FC = () => {
  const { t } = useTranslation();
  const { data, isSuccess, isError } = useGetActiveBalancesV2Query();

  const getAvailableRewardsAmount = () => {
    if (!isSuccess) {
      return null;
    }

    const amountOfGiftCards = data?.filter(
      (reward) => reward.rewardName === RewardName.GIFT_CARD
    ).length;
    if (!amountOfGiftCards) {
      return null;
    }

    return amountOfGiftCards;
  };

  const getRewardsText = () => {
    const availableRewardsAmount = getAvailableRewardsAmount();
    const hasRewards =
      availableRewardsAmount !== null && availableRewardsAmount > 0;

    const amount = hasRewards && !isError ? availableRewardsAmount : 0;

    if (amount === 0) {
      return t('refer.rewards.no_rewards');
    }

    return t('refer.rewards.amount', {
      amount,
    });
  };

  return (
    <>
      <div className="space-y-6 mt-12">
        <h3 className="text-2xl font-bold text-gray-900">
          {t('refer.rewards.title')}
        </h3>
        <p className="text-gray-600">{getRewardsText()}</p>
      </div>

      {isError && (
        <>
          <MarketToaster>
            <MarketToast variant="critical">
              {t('refer.rewardBalance.error')}
            </MarketToast>
          </MarketToaster>
        </>
      )}
    </>
  );
};

export default RewardsTracker;
